import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectVulnTemplateDetail } from 'store/KnowledgeBase/selectors';
import CustomList from 'Common/Components/CustomList';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import Wrapper from './styled';
import useExpandable from 'Hooks/useExpandable';
import { selectReadOnly } from 'store/Faraday/selectors';

const TAB = 'general';
const ID = 'references';

const References = () => {
  const dispatch = useDispatch();
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const list = get(vulnTemplate, 'refs');
  const id = get(vulnTemplate, '_id', 0);
  const intl = useIntl();
  const isExpanded = useExpandable(TAB, ID, list);
  const readOnly = useSelector(selectReadOnly);
  const canUpdate = !readOnly;

  const onAdd = (valueAdded) => {
    const newRefs = [...list, valueAdded];
    dispatch(updateVulnTemplate(id, { references: newRefs }));
  };
  const onRemove = (indexToRemove) => {
    const newRefs = list.filter((ref, index) => index !== indexToRemove);
    dispatch(updateVulnTemplate(id, { references: newRefs }));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="references" title={ intl.formatMessage({ id: 'manage.detail.tab.general.references' }) } tab={ TAB }>
      <Wrapper>
        <CustomList
          key="DETAIL_CREATION_MODAL"
          placeholder="Add a Reference"
          addItem={ onAdd }
          removeItem={ onRemove }
          listData={ list }
          responsive
          canUpdate={ canUpdate }
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default References;
